<template lang="html">
  <section class="gh-summit-section gh-testimonials">
    <div class="container">
      <h2 class="section-heading gh-heading gh-lightBlue">Praise from previous MHA Summits</h2>
      <p class="gh-body">
          Mental Health Academy Summits have been attended by over 150,000 mental health professionals worldwide, raising almost £1M for charity. Here is some of the feedback from previous participants.
      </p>
      <div class="comments-content" id="js-brick-container">
        <div v-for="(comment, index) in comments" :key="index"  class="testimonial-box" :class="comment.text ? '' : 'testimonial-box-no'">
            <p v-if="comment.text">{{'&ldquo;'+comment.text+'&rdquo;'}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Macy from 'macy'

export default {
  data () {
    return {
      macy: undefined,
      comments: [
        {
          text: "Just to offer my huge thanks and congratulations in gathering all the involved presenters who offered their knowledge and expertise on the concerned subject of suicide prevention. I found the entire program of great value and hugely beneficial.",
        },
        {
          text: "This was THE BEST! So happy and grateful I could attend the live sessions.",
        },
                {
          text: "Thank you so much for organising such an outstanding weekend of top quality presentations. I thoroughly enjoyed it.",
        },
        {
          text: "I want to thank you for devoting two days to organizing the Suicide Prevention Summit. I work in the substance abuse office, and the seminar was a tremendous success, adding more purpose to my work. The summit helped me better understand my clients, and I am now prepared to assist them.",
        },
        {
          text: "Thank you so much for this presentation. It was really helpful and contained lots of update for my practice.",
        },
        {
          text: "The summit was amazing and I just wanted to say thank you for providing such quality training for all of us. I look forward to accessing the presentation material and notes from the 2 days. I also loved the format of every other hour, allowing time for breaks, notes and opportunities to look up information presented during the former hour. Thank you again for your hard work and that of all involved.",
        },
        {
          text: "Linked historical and cultural narratives into contemporary language - very helpful in challenging current language and practice.",
        },
        {
          text: "Really useful & interesting information to reflect on - I think a lot of people can relate to that fear of losing a client to suicide and what that means about their skills/ability to keep people safe.",
        },
        {
          text: "Really useful summary of the variety of interventions. I found it relevant and thought provoking.",
        },
        {
          text: ''
        },
        {
          text: "Really good and varied speakers with a wide range of experience and clinical aspects covered.",
        },
      ]
    }
  },
  mounted () {
    this.macy = Macy({
        container: '#js-brick-container',
        trueOrder: this.device === 'mobile' || this.device === 'tablet' ? false : true,
        margin: 32,
        columns: 4,
        breakAt: {
            1024: 3,
            768: 2,
            414: 1
        }
    });
  },
  computed: {
      device() {
          return this.$store.getters['ui/getDevice'];
      }
  },


}

</script>

<style scoped lang="scss">
  $white: white;
  .gh-summit-section {
        padding: 2rem 0;
    }

  .gh-testimonials {
    background: #f0f1f2;
    .container {
      padding-top: 3rem;
      h2 {
        font-size: 2.3rem;
        margin-bottom: 2rem;
      }
    }
    p {
      line-height: 1.3;
      font-weight: 700;
      font-size: 1.1rem;
    }

    .gh-body {
      font-size: 1.6rem;
      margin: 10px 0 30px;
      font-weight: 500;
    }

    .comments-content {
      margin-bottom: -2rem;
    }

    .testimonial-box {
      background: #fff;
      padding: 1.1rem;
      text-align: center;
      box-shadow: 0 0 5px #cccccc;
      border-radius: 2px;
      color: #374785;
      font-weight: 700;
    }

    .testimonial-box-no {
      background: none;
      box-shadow: none;
    }

    .font-white {
        color: $white;
    }

    .white {
      background-color: $white;
    }
    .text-blue {
      color: #374785;
    }

    @media (max-width: 1023px) {
        .testimonial-box-no {
          display: none;
        }
    }
  }
</style>
